<template>
  <div
    class="app-container"
    v-loading="formLoading"
    style="height: 100%; background: white"
    :element-loading-text="$t('report.waiting')"
  >
    <el-row
      :style="
        buttonRowMargin || formEditStatus > 20 ? 'margin-bottom:10px' : ''
      "
      class="control-buttons"
      ref="buttonRow"
    >
      <el-button v-if="isWorkFlow" v-waves type="info" @click="handleSchedule"
        ><svg-icon icon-class="schedule" />{{
          $t("buttons.schedule")
        }}</el-button
      >
      <el-button
        type="primary"
        @click="SaveNewForm"
        v-if="formEditStatus === 10 && formType === 0 && buttonVisiable('4')"
      >
        <svg-icon icon-class="save"></svg-icon>
        {{ buttonName("4") }}
      </el-button>
      <el-button
        type="primary"
        @click="SaveCreateNewForm"
        v-if="formEditStatus === 10 && formType === 0 && buttonVisiable('5')"
      >
        <svg-icon icon-class="save"></svg-icon>
        {{ buttonName("5") }}
      </el-button>
      <el-button
        type="primary"
        @click="SaveEditedForm"
        v-if="formEditStatus === 12 && buttonVisiable('4')"
        ><svg-icon icon-class="save"></svg-icon>
        {{ buttonName("4") }}
      </el-button>
      <el-button
        type="primary"
        @click="SaveClose"
        v-if="
          (formEditStatus === 10 || formEditStatus === 12) &&
          formType === 0 &&
          buttonVisiable('6')
        "
      >
        <svg-icon icon-class="save"></svg-icon>
        {{ buttonName("6") }}
      </el-button>
      <el-button
        type="primary"
        @click="CreateNewForm"
        v-if="
          formEditStatus === 20 &&
          !dialogModel &&
          $refs.reportEditor &&
          $refs.reportEditor.templateRole &&
          $refs.reportEditor.templateRole.create &&
          buttonVisiable('1')
        "
        icon="el-icon-plus"
      >
        {{ buttonName("1") }}
      </el-button>
      <el-button
        type="primary"
        @click="EditForm"
        v-if="
          formEditStatus === 11 &&
          !lockState &&
          modifyRole &&
          buttonVisiable('2')
        "
        :disabled="
          $refs.reportEditor && $refs.reportEditor.systemValue.r13 !== 1
        "
        icon="el-icon-edit"
      >
        {{ buttonName("2") }}
      </el-button>
      <el-button
        type="primary"
        @click="CopyCreateForm"
        v-if="
          !isWorkFlow &&
          !dialogModel &&
          $refs.reportEditor &&
          $refs.reportEditor.templateRole &&
          $refs.reportEditor.templateRole.create &&
          buttonVisiable('8')
        "
      >
        <svg-icon icon-class="save"></svg-icon>
        {{ buttonName("8") }}
      </el-button>
      <el-button
        type="primary"
        @click="handleSubmit"
        :loading="submitLoading"
        v-if="formEditStatus === 30 || formEditStatus === 40"
        icon="el-icon-check"
        >{{ $t("buttons.launch") }}</el-button
      >
      <el-button
        type="warning"
        @click="pushWorkFlow(0)"
        :loading="saveLoading"
        v-if="(formEditStatus === 30 || formEditStatus === 40) && pause"
      >
        <svg-icon icon-class="save"></svg-icon>
        {{ buttonName("7") }}
      </el-button>
      <el-button
        type="warning"
        @click="TemporarySaveForm"
        v-if="formEditStatus === 10 && formType === 0 && buttonVisiable('7')"
      >
        <svg-icon icon-class="save"></svg-icon>
        {{ buttonName("7") }}
      </el-button>
      <el-button
        type="primary"
        @click="handleReview(1)"
        v-if="
          (formEditStatus === 20 || formEditStatus === 11) &&
          $refs.reportEditor &&
          $refs.reportEditor.templateRole &&
          $refs.reportEditor.templateRole.check &&
          $refs.reportEditor.systemValue.r13 === 1
        "
        icon="el-icon-check"
      >
        {{ $t("buttons.reviewReport") }}
      </el-button>
      <el-button
        type="primary"
        @click="handleReview(0)"
        v-if="
          (formEditStatus === 20 || formEditStatus === 11) &&
          $refs.reportEditor &&
          $refs.reportEditor.templateRole &&
          $refs.reportEditor.templateRole.uncheck &&
          $refs.reportEditor.systemValue.r13 === 2
        "
        icon="el-icon-back"
      >
        {{ $t("buttons.cancelReport") }}
      </el-button>
      <el-button
        type="danger"
        @click="handleReview(-1)"
        v-if="
          (formEditStatus === 20 || formEditStatus === 11) &&
          $refs.reportEditor &&
          $refs.reportEditor.templateRole &&
          $refs.reportEditor.templateRole.voided &&
          $refs.reportEditor.systemValue.r13 === 1
        "
        icon="el-icon-delete"
      >
        {{ $t("buttons.voidReport") }}
      </el-button>
      <template v-if="buttonVisiable('9')&&!anonymous">
        <el-popover
          v-if="
            formEditStatus === 10 ||
            formEditStatus === 12 ||
            formEditStatus === 30 ||
            formEditStatus === 40
          "
          placement="bottom"
          width="200"
          v-model="closeVisiable"
        >
          <p>{{ $t("alert.close") }}</p>
          <div style="text-align: right; margin: 0">
            <el-button size="mini" type="text" @click="closeVisiable = false">{{
              $t("buttons.cancel")
            }}</el-button>
            <el-button type="primary" size="mini" @click="AbortForm(true)">{{
              $t("buttons.confirm")
            }}</el-button>
          </div>
          <el-button slot="reference" type="danger" icon="el-icon-close">{{
            buttonName("9")
          }}</el-button>
        </el-popover>
        <el-button
          type="danger"
          @click="AbortForm"
          icon="el-icon-close"
          v-else
          >{{ buttonName("9") }}</el-button
        >
      </template>
      <el-button
        type="danger"
        @click="SendBackWorkFlow"
        v-if="formEditStatus === 40"
        >{{ $t("buttons.rollBack") }}</el-button
      >
      <!-- <el-button @click="ExecQueryFormula" icon="el-icon-search" v-if="(formEditStatus===10||formEditStatus===12)&&queryFormulaList.length>0&&formType===0">查询_old</el-button> -->
      <el-dropdown
        v-if="outputRole === 3 && (formEditStatus !== 10 || formType === 1)"
        @command="HandleOutPutCommand"
        trigger="click"
        style="margin-right: 10px"
        :style="lockState && formEditStatus === 12 ? '' : 'margin-left: 10px;'"
      >
        <el-button>
          {{ $t("buttons.export")
          }}<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="xlsx">{{
            $t("buttons.excel")
          }}</el-dropdown-item>
          <el-dropdown-item command="pdf">{{
            $t("buttons.pdf")
          }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button
        @click="HandleOutPutCommand('xlsx')"
        v-if="outputRole === 2 && (formEditStatus !== 10 || formType === 1)"
        >{{ $t("buttons.exportExcel") }}</el-button
      >
      <el-button
        @click="HandleOutPutCommand('pdf')"
        v-if="outputRole === 1 && (formEditStatus !== 10 || formType === 1)"
        >{{ $t("buttons.exportPdf") }}</el-button
      >
      <template
        v-if="
          printRole &&
          (formEditStatus !== 10 || formType === 1) &&
          $refs.reportEditor &&
          viewHost === 0
        "
      >
        <el-dropdown
          v-if="
            printObjectList.length > 1 ||
            (printObjectList.length === 1 &&
              $refs.reportEditor.printProperty &&
              $refs.reportEditor.printProperty.preview)
          "
          trigger="click"
          placement="bottom-start"
        >
          <el-button
            style="margin-right: 10px; margin-left: 10px"
            icon="el-icon-printer"
          >
            {{ $t("buttons.print")
            }}<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="object in printObjectList"
              v-bind:key="object.guid"
              class="print-item"
            >
              <span @click="handlePrint(object.guid)">{{
                object.name || object.guid
              }}</span>
              <el-button
                type="text"
                class="preview-button"
                size="mini"
                icon="el-icon-view"
                v-if="
                  $refs.reportEditor &&
                  ($refs.reportEditor.printProperty === undefined ||
                    $refs.reportEditor.printProperty.preview)
                "
                @click="handlePreview(object.guid)"
              ></el-button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button
          v-else-if="printObjectList.length === 1"
          @click="handlePrint(printObjectList[0].guid)"
          icon="el-icon-printer"
          >{{ $t("buttons.print") }}</el-button
        >
        <el-button @click="showPrintAlert()" v-else icon="el-icon-printer">{{
          $t("buttons.print")
        }}</el-button>
      </template>
      <el-button
        @click="HistoryFroms"
        v-if="
          formEditStatus < 30 &&
          formType === 0 &&
          !dialogModel &&
          $refs.reportEditor &&
          $refs.reportEditor.templateRole &&
          $refs.reportEditor.templateRole.view &&
          buttonVisiable('10')
        "
      >
        <svg-icon icon-class="record"></svg-icon>
        {{ buttonName("10") }}
      </el-button>
      <el-button
        type="success"
        v-if="
          $refs.reportEditor &&
          $refs.reportEditor.paginationItems &&
          $refs.reportEditor.paginationItems.length &&
          recalcMark > 0
        "
        :disabled="pageinationEnabled(-1) && recalcMark > 0"
        @click="pageChange(-1)"
        :title="paginationText()"
        >{{ buttonName("11") }}</el-button
      >
      <el-button
        type="success"
        v-if="
          $refs.reportEditor &&
          $refs.reportEditor.paginationItems &&
          $refs.reportEditor.paginationItems.length &&
          recalcMark > 0
        "
        :disabled="pageinationEnabled(1) && recalcMark > 0"
        @click="pageChange(1)"
        :title="paginationText()"
        >{{ buttonName("12") }}</el-button
      >
      <span
        :key="actionInfo.id"
        v-for="actionInfo in actionButtons"
        v-if="(actionInfo.position & 1) === 1"
      >
        <el-button
          v-if="
            !actionInfo.style.switchable ||
            (actionInfo.style.switchable && !actionInfo.clickedStatus)
          "
          :disabled="actionRunning"
          style="margin-left: 10px"
          :loading="actionRunning && hendleActionCommand === actionInfo.id"
          @click="actionButtonClick(actionInfo.id)"
          :type="actionInfo.style.type"
          :icon="
            actionInfo.style.iconSide !== 'right' ? actionInfo.style.icon : ''
          "
          :plain="actionInfo.style.theme === 'plain'"
          :round="actionInfo.style.shape === 'round'"
          :circle="actionInfo.style.shape === 'circle'"
          :class="
            actionInfo.style.alias === '' || !actionInfo.style.showAlias
              ? 'el-button-no-content'
              : ''
          "
        >
          {{ actionInfo.style.showAlias ? actionInfo.style.alias : "" }}
          <i
            v-if="
              actionInfo.style.iconSide === 'right' && actionInfo.style.icon
            "
            :class="actionInfo.style.icon + ' el-icon--right'"
          ></i
        ></el-button>
        <el-button
          v-else-if="
            actionInfo.style.changedAlias || actionInfo.style.changedIcon
          "
          :type="actionInfo.style.changedType"
          :icon="
            actionInfo.style.iconSide !== 'right'
              ? actionInfo.style.changedIcon
              : ''
          "
          style="margin-left: 10px"
          :plain="actionInfo.style.theme === 'plain'"
          :round="actionInfo.style.shape === 'round'"
          :circle="actionInfo.style.shape === 'circle'"
          :class="
            actionInfo.style.changedAlias === '' ||
            !actionInfo.style.showChangedAlias
              ? 'el-button-no-content'
              : ''
          "
          @click="actionButtonClick(actionInfo.id)"
        >
          {{
            actionInfo.style.showChangedAlias
              ? actionInfo.style.changedAlias
              : ""
          }}
          <i
            v-if="
              actionInfo.style.iconSide === 'right' &&
              actionInfo.style.changedIcon
            "
            :class="actionInfo.style.changedIcon + ' el-icon--right'"
          ></i
        ></el-button>
      </span>
      <el-button
        type="primary"
        v-if="connectbuttonInfos.length === 1"
        @click="connectLinkHandler(connectbuttonInfos)"
        :loading="loadingCommand === connectbuttonInfos[0].id"
      >
        {{
          connectbuttonInfos[0].alias ||
          connectbuttonInfos[0].name ||
          $t("buttons.relatedReport") + connectbuttonInfos[0].id
        }}
      </el-button>
      <el-dropdown
        trigger="click"
        @command="
          connectLinkHandler(
            connectbuttonInfos.filter((info) => info.id === +$event)
          )
        "
        v-if="connectbuttonInfos.length > 1"
      >
        <el-button type="primary" style="margin-left: 10px">
          {{ $t("buttons.relevantReport")
          }}<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="info in connectbuttonInfos"
            v-bind:key="info.id"
            :command="info.id"
            >{{
              info.alias || info.name || $t("buttons.relatedReport") + info.id
            }}</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
      <el-button
        type="primary"
        v-if="sendMailButtonInfos.length === 1"
        @click="sendMail(sendMailButtonInfos[0].id)"
        :loading="loadingCommand === sendMailButtonInfos[0].id"
      >
        {{
          sendMailButtonInfos[0].name ||
          $t("buttons.sendEmail") + sendMailButtonInfos[0].id
        }}
      </el-button>
      <el-dropdown
        trigger="click"
        @command="sendMail"
        v-if="sendMailButtonInfos.length > 1"
      >
        <el-button type="primary" style="margin-left: 10px">
          {{ $t("buttons.sendEmail")
          }}<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="info in sendMailButtonInfos"
            v-bind:key="info.id"
            :command="info.id"
            >{{
              info.alias || info.name || $t("buttons.sendEmail") + info.id
            }}</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>

      <div
        class="form-flip"
        v-if="
          currentFormFilter && (formEditStatus === 11 || formEditStatus === 20)
        "
      >
        <el-button
          circle
          @click="changeForm('up')"
          :disabled="pageTurning || firstRecord"
          icon="el-icon-arrow-up"
        />
        <el-button
          circle
          @click="changeForm('down')"
          :disabled="pageTurning || lastRecord"
          icon="el-icon-arrow-down"
        />
      </div>
      <div class="tips" v-if="$refs.reportEditor">
        <span
          v-if="$refs.reportEditor.systemValue.r13 === 2"
          style="color: #67c23a"
        >
          已审核
          <svg-icon icon-class="examined" />
        </span>
        <span
          v-else-if="$refs.reportEditor.systemValue.r13 === 3"
          style="color: #808080"
        >
          已作废
          <svg-icon icon-class="voided" />
        </span>
      </div>
      <!-- <div v-loading="functionLoading" element-loading-spinner="el-icon-loading"
        element-loading-text="处理中" style="width:5%;position:fixed;right:10px;margin-top:-18px">
      </div> -->
    </el-row>
    <el-row
      :style="
        buttonRowMargin || formEditStatus > 20
          ? 'height: calc(100% - 50px);'
          : 'height: 100%'
      "
    >
      <split-pane
        ref="splitPane"
        @resize="resize"
        split="vertical"
        :min-percent="minPercent"
        :default-percent="100"
      >
        <template slot="paneL">
          <!-- 控件 -->
          <FormEditor
            v-if="viewHost === 1"
            ref="reportEditor"
            :connectProps="connectProps"
            :useRouter="!dialogModel"
            :formEditStatus="formEditStatus"
            :queryFormulaIds="queryFormulaIds"
            :workflowTaskId="workflowTaskId"
            @changeFromType="changeFromType"
            @loadedAction="loadedAction"
            @getAttribute="getAttribute"
            @ChangeFormEditStatus="ChangeFormEditStatus"
            @ChangeLoadingStatus="ChangeLoadingStatus"
            @ChangeFunctionLoadingStatus="ChangeFunctionLoadingStatus"
            @UpdateQueryFormulaList="UpdateQueryFormulaList"
            @buildConnectButtons="buildConnectButtons"
            @buildMailButtons="buildMailButtons"
            @buildFieldButtons="buildFieldButtons"
            @buildActionButtons="buildActionButtons"
            @connectLinkClick="connectLinkClick"
            @connectLinkHandler="connectLinkHandler"
            @SaveNewForm="SaveNewForm"
            @changeLinkParam="changeLinkParam"
            @handleConnect="handleConnect"
            @SaveCreateNewForm="SaveCreateNewForm"
            @EditForm="EditForm"
            @AbortForm="AbortForm"
            @CopyCreateForm="CopyCreateForm"
            @setUnpause="setUnpause"
            @actionButtonClick="actionButtonClick"
            @updatePrintList="updatePrintList"
            @recalc="recalc"
            @pageChange="pageChange"
            @TemporarySaveForm="TemporarySaveForm"
            @setActivity="setActivity"
          />
          <!-- 表格 -->
          <report-editor
            v-if="viewHost === 0"
            ref="reportEditor"
            key="reportEditor"
            :connectProps="connectProps"
            :useRouter="!dialogModel"
            :formEditStatus="formEditStatus"
            :queryFormulaIds="queryFormulaIds"
            :workflowTaskId="workflowTaskId"
            @changeSize="changeSize"
            @setActivity="setActivity"
            @ChangeRole="ChangeRole"
            @changeFromType="changeFromType"
            @loadedAction="loadedAction"
            @getAttribute="getAttribute"
            @ChangeFormEditStatus="ChangeFormEditStatus"
            @ChangeLoadingStatus="ChangeLoadingStatus"
            @ChangeFunctionLoadingStatus="ChangeFunctionLoadingStatus"
            @UpdateQueryFormulaList="UpdateQueryFormulaList"
            @buildConnectButtons="buildConnectButtons"
            @buildMailButtons="buildMailButtons"
            @buildFieldButtons="buildFieldButtons"
            @buildActionButtons="buildActionButtons"
            @connectLinkClick="connectLinkClick"
            @connectLinkHandler="connectLinkHandler"
            @SaveNewForm="SaveNewForm"
            @changeLinkParam="changeLinkParam"
            @handleConnect="handleConnect"
            @SaveCreateNewForm="SaveCreateNewForm"
            @EditForm="EditForm"
            @AbortForm="AbortForm"
            @CopyCreateForm="CopyCreateForm"
            @setUnpause="setUnpause"
            @actionButtonClick="actionButtonClick"
            @updatePrintList="updatePrintList"
            @recalc="recalc"
            @pageChange="pageChange"
            @TemporarySaveForm="TemporarySaveForm"
          >
          </report-editor>
        </template>
      </split-pane>
    </el-row>
    <!-- 提交 -->
    <submit-dialog
      :submitVisible="submitVisible"
      :editLoading="editLoading"
      :activity="activity"
      :comboList="comboList"
      @submitDialogClose="
        submitVisible = false;
        messageDialog = false;
      "
      :submitCandidateList="submitCandidateList"
      :submitDialogLoading.sync="submitDialogLoading"
      @saveCandidates="pushSubmit"
    >
    </submit-dialog>
    <!-- 超链接 -->
    <el-dialog
      append-to-body
      v-el-drag-dialog
      :modal="false"
      :title="`${$t('buttons.total')}${
        linkReportList.data ? linkReportList.data.length : 0
      }${$t('preview.links')}`"
      :visible.sync="showLinkReportList"
      width="35%"
    >
      <w-table
        tableHeight="400px"
        :sortable="false"
        :hasPagination="false"
        :showToolBar="false"
        tableSize="mini"
        tableType="link"
        :table-data="linkReportList.data || []"
        :table-header="linkReportList.header"
        @handleRowClick="
          connectLinkClick(
            currentButton,
            $event.rid,
            'link',
            linkReportListType
          )
        "
      />
    </el-dialog>
    <!-- <ImageViewer ref="ImageViewer" v-if="imageviewerVisiable"></ImageViewer> -->
    <!-- 进度 -->
    <Drawer
      :title="$t('buttons.schedule')"
      width="270"
      :transfer="false"
      v-model="scheduleVisible"
    >
      <schedule
        :instanceId="instanceId"
        :unfinished="unfinished"
        :workFlowId="workFlowId"
        :scheduleList="scheduleList"
        v-loading="scheduleLoading"
      >
      </schedule>
    </Drawer>
  </div>
</template>

<script>
import FormEditor from './FormEditor/index.vue'
import Schedule from '@/views/WorkFlow/components/Schedule'
import zango from '@/mixins/zango.js'
import { downloadFile } from '@/api/largeFile.js'
import WTable from '@/components/WTable'
// import Cookies from 'js-cookie'
import { parseTime } from '@/utils'
import ReportDialog from '@/components/ReportDialog/index.vue'
import { getFormData, getTemplateState, getAttribute, GetTemplatePermission, reportOperation } from '@/api/form.js'
import splitPane from 'vue-splitpane'
import ReportEditor from './ReportEditor/index.vue'
import print from './ReportEditor/js/print.js'
import { handleWorkFlowTask, getWorkFlowTaskCandidate, getWorkFlowTargets, getDataSpecCombo } from '@/api/workFlow.js'
import { getConnectLinkSheetList, getLinkSheetList, checkFormEditable, getTemplateAttribute, getPreviewWorkFlowTasksSchedule, getContextForm } from '@/api/preview'
import SubmitDialog from '@/views/WorkFlow/components/SubmitDialog/index.vue'
import { mapGetters } from 'vuex'
import formatConverter from './ReportEditor/js/formatConverter.js'
// import ImageViewer from '@/components/ImageViewer/index.vue'
export default {
  name: 'report',
  mixins: [zango],
  components: {
    FormEditor,
    ReportEditor,
    SubmitDialog,
    splitPane,
    ReportDialog,
    WTable,
    Schedule
    // ImageViewer
  },
  props: {
    connectProps: {
      type: Object,
      default() {
        return {}
      }
    },
    dialogModel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentRoutePath: '',
      // 弹窗模式下数据
      rowData: {},
      // 展示模式
      viewHost: undefined, // 0：表格 1:控件
      instanceId: '',
      unfinished: [],
      isWorkFlow: false,
      workFlowId: 0,
      scheduleList: [],
      scheduleVisible: false,
      scheduleLoading: false,
      defaultValue: '',
      mutableNames: [
        { subId: '1', value: this.$t('buttons.create'), state: true },
        { subId: '2', value: this.$t('buttons.edit'), state: true },
        { subId: '3', value: this.$t('buttons.check'), state: true },
        { subId: '4', value: this.$t('buttons.save'), state: true },
        { subId: '5', value: this.$t('buttons.saveAndCreate'), state: true },
        { subId: '6', value: this.$t('buttons.saveAndClose'), state: false },
        { subId: '7', value: this.$t('buttons.temporary'), state: true },
        { subId: '8', value: this.$t('buttons.copyCreate'), state: false },
        { subId: '9', value: this.$t('buttons.close'), state: true },
        { subId: '10', value: this.$t('buttons.history'), state: true }
      ],
      // 状态调整变更
      // 10=新增
      // 11=查看
      // 12=修改
      // 20=保存
      // 30=发起流程
      // 40=办理流程
      // 50=查看流程
      type: 'report',
      currentButton: 0,
      connectData: {},
      pause: true,
      parseTime: parseTime,
      lockState: false,
      minPercent: 100,
      span: 24,
      splitPanePercent: 80,
      editLoading: false,
      comboList: [],
      activity: {},
      linkReportListType: null,
      submitVisible: false,
      closeVisiable: false,
      submitDialogLoading: false,
      submitCandidateList: { list: [] },
      formEditStatus: 10,
      queryFormulaList: [],
      outputRole: 0,
      printRole: false,
      modifyRole: false,
      formLoading: false,
      functionLoading: false,
      submitLoading: false,
      saveLoading: false,
      queryFormulaIds: [],
      workFlowType: {
        1: this.$t('buttons.submit'),
        0: this.$t('buttons.temporary')
      },
      workFlowTypeLoading: {
        1: 'submitLoading',
        0: 'saveLoading'
      },
      formType: 0,
      // 所有关联填报信息
      connectbuttonInfos: [],
      sendMailButtonInfos: [],
      fieldbuttonInfos: [],
      linkButtonInfos: [],
      linkReportList: { data: [] },
      showLinkReportList: false,
      loadingCommand: null,
      handleCommand: -1,
      actionButtons: [],
      actionRunning: false,
      hendleActionCommand: -1,
      loaded: false,
      deleted: false,
      printObjectList: [],
      workflowTaskId: null,
      thisTab: null,
      startTime: null,
      currentFormFilter: null,
      pageTurning: false,
      recordIdList: [],
      firstRecord: false,
      lastRecord: false,
      buttonRowMargin: true,
      recalcMark: 1,
      anonymous: false
    }
  },
  mounted() {
    this.anonymous = !!this.getUrlKey('anonymous')
    if (!this.dialogModel) {
      this.currentRoutePath = this.$route.path
      this.$bus.$on('createFn', (route) => {
        this.$nextTick(() => {
          // 点击新建时，如果已经是保存状态，则刷新view
          if (route.path === this.currentRoutePath && this.formEditStatus !== 10) {
            this.formEditStatus = 10
            console.log('createFn')
            this.CreateNewForm()
          }
        })
      })
    }
  },
  activated() {
    this.startTime = new Date().getTime()
    if (this.$refs.reportEditor && this.$refs.reportEditor.spreadSheet && this.$refs.reportEditor.scrollerParam) {
      this.$refs.reportEditor.spreadSheet._view.scroller.scrollTop = this.$refs.reportEditor.scrollerParam.top
      this.$refs.reportEditor.spreadSheet._view.scroller.scrollLeft = this.$refs.reportEditor.scrollerParam.left
    }
    if (!this.dialogModel) {
      var refresh = false
      if (this.storeTemporaryId && !this.$store.getters.needRefresh) {
        if (this.formEditStatus === 10) {
          this.$message({
            message: '请先处理当前单据再进行操作！',
            type: 'warning'
          })
          this.$store.dispatch('setTemporaryId', null)
        } else {
          refresh = true
        }
      }
      if (this.$store.getters.needRefresh || refresh) {
        // this.ChangeLoadingStatus(true)
        this.loaded = false
        this.deleted = false
        this.$nextTick(() => {
          this.currentFormFilter = JSON.parse(JSON.stringify(this.formFilter))
          console.log(this.currentFormFilter)
          // 判断自己是不是第一条或最后一条
          if (this.currentFormFilter) {
            if (this.currentFormFilter.tableDataQueryTotal === this.currentFormFilter.currentIndex) {
              this.lastRecord = true
            }
            if (this.currentFormFilter.pageIndex === 1 && this.currentFormFilter.currentIndex === 1) {
              this.firstRecord = true
            }
            this.$store.dispatch('setFormFilter', null)
          }
          this.formEditStatus = this.$route.params.workFlowId !== undefined ? 30 : 10
          this.getTemplateAttribute().then(() => {
            this.$refs.reportEditor.editModel = +this.$route.params.model
            this.$refs.reportEditor.InitializeReport()
            this.getTemplateState(+this.$refs.reportEditor.templateId, +this.$refs.reportEditor.recordId)
          })
          // }, 5000)
        })
        this.thisTab = this.$store.state.tagsView.lastTab
      } else {
        this.$store.dispatch('setDisableTree', false)
      }
    }
  },
  beforeDestroy() {
    this.$bus.$off('createFn')
  },
  // deactivated() {
  //   this.$bus.$off('createFn')
  // },
  computed: {
    defaultPercent() {
      return this.$store.state.app.defaultPercent
    },
    ...mapGetters(['formFilter', 'storeTemporaryId', 'lastTab'])
  },
  watch: {
    defaultPercent() {
      this.splitPanePercent = this.$refs.splitPane.percent
      if (this.$refs.reportEditor.spreadSheet) {
        this.$refs.reportEditor.spreadSheet.resize()
      }
    }
  },
  methods: {
    getUrlKey(name) {
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
    },
    buttonVisiable(id) {
      if (id) {
        if ((this.mutableNames.find(m => m.subId === id) ? this.mutableNames.find(m => m.subId === id).state : true) || this.mutableNames.length === 0) {
          return true
        } else {
          return false
        }
      } else {
        if (this.$refs.buttonRow && this.$refs.buttonRow.$children && this.$refs.buttonRow.$children.length) {
          return true
        } else {
          return false
        }
      }
    },
    buttonName(id) {
      var nameList = {
        '1': this.$t('buttons.create'),
        '2': this.$t('buttons.edit'),
        '4': this.$t('buttons.save'),
        '5': this.$t('buttons.saveAndCreate'),
        '6': this.$t('buttons.saveAndClose'),
        '7': this.$t('buttons.temporary'),
        '8': this.$t('buttons.copyCreate'),
        '9': this.$t('buttons.close'),
        '10': this.$t('buttons.history'),
        '11': '上一页',
        '12': '下一页'
      }
      var buttonProfile = this.mutableNames.find(m => m.subId === id)
      console.log(buttonProfile ? buttonProfile.value : nameList[id])
      return buttonProfile ? buttonProfile.value : nameList[id]
    },
    setUnpause(unpuase) {
      console.log(unpuase)
      this.pause = !unpuase
    },
    buttonRowSize() {
      this.$nextTick(() => {
        if (this.$refs.buttonRow && this.$refs.buttonRow.$children && this.$refs.buttonRow.$children.length) {
          this.buttonRowMargin = true
        } else {
          this.buttonRowMargin = false
        }
      })
    },
    loadedAction() {
      return
      // if (this.startTime) {
      //   var usedTime = (new Date().getTime()) - this.startTime
      //   if (usedTime <= 1000000) {
      //     this.$message({
      //       message: `本次打开耗时${usedTime}毫秒`,
      //       type: 'warning'
      //     })
      //     console.log(`本次打开耗时${usedTime}毫秒`)
      //   }
      // }
    },
    changeForm(direction) {
      this.pageTurning = true
      this.$nextTick(async () => {
        console.log(this.currentFormFilter)
        var needRefresh = false
        // 判断要不要翻页
        if (direction === 'down') {
          if (!(this.currentFormFilter.currentIndex % this.currentFormFilter.pageSize)) {
            this.currentFormFilter.pageIndex += 1
            needRefresh = true
          }
          this.currentFormFilter.currentIndex += 1
        } else if (direction === 'up') {
          if (this.currentFormFilter.currentIndex % this.currentFormFilter.pageSize === 1) {
            this.currentFormFilter.pageIndex -= 1
            needRefresh = true
          }
          this.currentFormFilter.currentIndex -= 1
        }
        if (needRefresh || !this.recordIdList || this.recordIdList.length === 0) {
          await this.getRecordIdList(direction)
        }
        var nextRecordId = -1
        nextRecordId = this.recordIdList[(this.currentFormFilter.currentIndex > this.currentFormFilter.pageSize ? (this.currentFormFilter.currentIndex % this.currentFormFilter.pageSize) : this.currentFormFilter.currentIndex) - 1]
        if (nextRecordId) {
          this.$store.dispatch('setFormFilter', this.currentFormFilter)
          this.$refs.reportEditor.recordId = nextRecordId
          this.startTime = new Date().getTime()
          await this.$refs.reportEditor.InitializeReportLite()
          this.lastRecord = this.firstRecord = false
          if (this.currentFormFilter.pageIndex === 1 && this.currentFormFilter.currentIndex === 1) {
            this.firstRecord = true
          }
          if (this.currentFormFilter.tableDataQueryTotal === this.currentFormFilter.currentIndex) {
            this.lastRecord = true
          }
        } else {
          this.$message({
            message: this.$t('report.noRecord'),
            type: 'error'
          })
        }
        this.pageTurning = false
        console.log('换页完成')
      })
    },
    // 获取翻页
    async getRecordIdList() {
      var recordList = (await getContextForm(this.$refs.reportEditor.templateId, this.currentFormFilter)).data
      this.recordIdList = recordList.data
    },
    getAttribute(recordId) {
      getAttribute(+this.$refs.reportEditor.templateId, recordId || -1).then(res => {
        this.isWorkFlow = res.data.workflowInstance !== null && res.data.workflowInstance !== undefined && res.data.workflowInstance !== ''
      })
    },
    // 查看进度
    handleSchedule() {
      this.scheduleList = []
      this.scheduleLoading = true
      this.scheduleVisible = true
      getPreviewWorkFlowTasksSchedule(+this.$refs.reportEditor.templateId, +this.$refs.reportEditor.recordId).then(res => {
        this.instanceId = res.data.instanceId
        this.unfinished = res.data.unfinished
        this.scheduleList = res.data.schedule
        this.workFlowId = res.data.workflowId
        this.scheduleLoading = false
      }).catch(() => {
        this.scheduleLoading = false
      })
    },
    // 获取模板属性
    getTemplateAttribute(tid) {
      // this.getAttribute()
      const templateId = tid || this.rowData.id || +this.$route.params.templateId
      // debugger
      return new Promise(resolve => {
        getTemplateAttribute(templateId).then(response => {
          if (response.data.mutableNames.length) {
            this.mutableNames = response.data.mutableNames
          }
          this.buttonRowSize()
          this.editMode = response.data.editMode
          this.viewMode = response.data.viewMode
          this.addMode = response.data.addMode
          this.displayMode = response.data.displayMode
          this.viewHost = response.data.viewHost
          resolve()
        })
      })
    },
    handleConnect(dataRow, model, connectData, reportTitle) {
      this.$emit('handleConnect', dataRow, model, connectData, reportTitle)
    },
    getTemplateState(templateId, recordId) {
      if (+this.$route.params.model !== 0) {
        getTemplateState(templateId, recordId).then(response => {
          this.lockState = response.data.formlock
        })
      }
    },
    resize() {
      if (!this.dialogModel) {
        this.splitPanePercent = this.$refs.splitPane.percent
        if (this.$refs.reportEditor.spreadSheet) {
          this.$refs.reportEditor.spreadSheet.resize()
        }
      }
    },
    ChangeFormEditStatus(targetStatus, state, norefresh) {
      if (this.$refs.reportEditor.templateAttribute.type === 0) {
        if (!this.$refs.reportEditor.dialogModel) {
          // 切换tab名称
          var data = {
            name: '',
            routeType: ''
          }
          const lastTab = this.$store.state.tagsView.lastTab
          if (lastTab && lastTab.name) {
            switch (targetStatus) {
              case 10:
                data.name = lastTab.name.substring(0, lastTab.name.indexOf('-')) + '-' + this.$t('buttons.create')
                data.routeType = 'create'
                this.$store.dispatch('ChangeLastTab', data)
                break
              case 50:
              case 51:
              case 11:
                data.name = lastTab.name.substring(0, lastTab.name.indexOf('-')) + '-' + this.$t('buttons.check')
                data.routeType = 'check'
                this.$store.dispatch('ChangeLastTab', data)
                break
              case 12:
                data.name = lastTab.name.substring(0, lastTab.name.indexOf('-')) + '-' + this.$t('buttons.edit')
                data.routeType = 'edit'
                this.$store.dispatch('ChangeLastTab', data)
                break
              case 20:
                data.name = lastTab.name.substring(0, lastTab.name.indexOf('-')) + '-' + this.$t('buttons.check')
                data.routeType = 'check'
                this.$store.dispatch('ChangeLastTab', data)
                break
              case 30:
                lastTab.name = lastTab.name.substring(0, lastTab.name.indexOf('-')) + '-' + this.$t('buttons.start')
                break
              case 40:
                lastTab.name = lastTab.name.substring(0, lastTab.name.indexOf('-')) + '-' + this.$t('buttons.handle')
                break
            }
          }
        } else {
          this.$emit('changeTitle', targetStatus)
        }
      }
      this.formEditStatus = targetStatus
      this.loaded = true
      if (!norefresh) {
        this.$nextTick(() => {
          if (this.$refs.reportEditor.spreadSheet) {
            this.$refs.reportEditor.spreadSheet._workbook._view.render()
          }
        })
      }
      // this.ChangeLoadingStatus(false)
    },
    ChangeLoadingStatus(status) {
      if (status === undefined) {
        this.formLoading = !this.formLoading
        this.$store.dispatch('setDisableTree', false)
      } else {
        this.formLoading = status
        this.$store.dispatch('setDisableTree', status)
      }
    },
    ChangeRole(item, value) {
      switch (item) {
        case 'print':
          this.printRole = value
          break
        case 'output':
          this.outputRole = value
          break
        case 'modify':
          this.modifyRole = value
          GetTemplatePermission(this.$store.getters.userId, +this.$refs.reportEditor.templateId, +this.$refs.reportEditor.recordId).then(response => {
            this.modifyRole = response.data.modify
          })
          break
      }
    },
    ChangeFunctionLoadingStatus(status) {
      if (status === undefined) {
        this.functionLoading = !this.functionLoading
      } else {
        this.functionLoading = status
      }
    },
    getFocus() {
      if (this.$refs.reportEditor.getFocus) {
        this.$refs.reportEditor.getFocus()
      }
    },
    // 普通单据控制
    async SaveNewForm() {
      // 保存单据
      this.ChangeLoadingStatus(true)
      if (await this.$refs.reportEditor.ChangeFormStatus(20)) {
        this.getFocus()
        this.ChangeLoadingStatus(false)
        return true
      } else {
        this.getFocus()
        this.ChangeLoadingStatus(false)
        return false
      }
    },
    async SaveClose() {
      if (this.formEditStatus === 10) {
        if (await this.SaveNewForm()) {
          this.AbortForm()
        }
      } else if (this.formEditStatus === 12) {
        if (await this.SaveEditedForm()) {
          this.AbortForm()
        }
      }
    },
    SaveCreateNewForm() {
      // 保存单据并继续填报新单据
      this.ChangeLoadingStatus(true)
      this.$refs.reportEditor.SaveNewForm(true)
      this.getFocus()
    },
    async TemporarySaveForm() {
      var reportData = await this.$refs.reportEditor.GetWholeData()
      if (this.$refs.reportEditor.temporaryId) {
        // var temporaryInfo= await this.findTemporarys(this.$refs.reportEditor.templateId,this.$refs.reportEditor.temporaryId)
        try {
          // 保存时上传附件的处理
          await this.$refs.reportEditor.UploadFiles()
          await this.updateTemporaryData({
            templateId: +this.$refs.reportEditor.templateId,
            date: new Date().getTime(),
            data: reportData,
            remark: null,
            guid: this.$refs.reportEditor.temporaryId
          })
          this.$message({
            message: this.$t('report.temporarySuccess'),
            type: 'success'
          })
        } catch (ex) {
          console.error(ex)
        }
      } else {
        // 暂存
        try {
          await this.$refs.reportEditor.UploadFiles()
          var temporaryId = await this.insertTemporaryData({
            templateId: +this.$refs.reportEditor.templateId,
            date: new Date().getTime(),
            data: reportData,
            remark: null
          })
          this.$refs.reportEditor.temporaryId = temporaryId
          this.$message({
            message: this.$t('report.temporarySuccess'),
            type: 'success'
          })
        } catch (ex) {
          console.error(ex)
        }
      }
    },
    CreateNewForm(copyCreateTag) {
      this.ChangeLoadingStatus(true)
      this.$refs.reportEditor.editModel = 0
      this.$route.params.model = 0
      this.$refs.reportEditor.InitializeReport(undefined, undefined, copyCreateTag)
      this.getFocus()
    },
    EditForm() {
      // 修改单据
      checkFormEditable(+this.$refs.reportEditor.templateId, +this.$refs.reportEditor.recordId).then(response => {
        if (response.status >= 200 && response.status < 300) {
          this.ChangeLoadingStatus(true)
          this.$refs.reportEditor.ChangeFormStatus(12)
          this.getFocus()
          this.$emit('handleEditForm')
        }
      })
    },
    async SaveEditedForm() {
      // 保存修改状态下的单据
      this.ChangeLoadingStatus(true)
      var result = await this.$refs.reportEditor.ChangeFormStatus(20)
      this.getFocus()
      return result
    },
    async CopyCreateForm() {
      var saveStatus = true
      if (this.formEditStatus === 10) {
        saveStatus = await this.SaveNewForm()
      } else if (this.formEditStatus === 12) {
        saveStatus = await this.SaveEditedForm()
      }
      if (saveStatus) {
        this.$store.dispatch('setCopyCreateRID', this.$refs.reportEditor.recordId)
        this.CreateNewForm(true)
      }
    },
    closeSelectedTag() {
      let latestView
      this.$store.getters.visitedViews.forEach((tab, index) => {
        if (tab.path === this.$store.state.tagsView.lastTab.path) {
          const nextTab = this.$store.getters.visitedViews[index + 1] || this.$store.getters.visitedViews[index - 1]
          if (nextTab) {
            latestView = nextTab
            this.$store.dispatch('delView', this.$store.state.tagsView.lastTab).then(({ visitedViews }) => {
              if (latestView.path === '/dashboard') {
                this.$router.push(latestView.path)
                localStorage.removeItem('lastTab')
              } else {
                const url = latestView.path
                this.$router.push(url)
                this.$store.dispatch('SetLastTab', latestView)
                this.deleted = true
              }
            })
          }
        }
      })
    },
    closeCurrentTag() {
      let latestView
      this.$store.getters.visitedViews.forEach((tab, index) => {
        if (tab.path === this.thisTab.path) {
          const nextTab = this.$store.getters.visitedViews[index + 1] || this.$store.getters.visitedViews[index - 1]
          if (nextTab) {
            latestView = nextTab
            this.$store.dispatch('delView', this.thisTab).then(({ visitedViews }) => {
              if (latestView.path === '/dashboard') {
                this.$router.push(latestView.path)
                localStorage.removeItem('lastTab')
              } else {
                const url = latestView.path
                this.$router.push(url)
                this.$store.dispatch('SetLastTab', latestView)
                this.deleted = true
              }
            })
          }
        }
      })
    },
    // 关闭单据
    AbortForm(withoutAlert) {
      this.closeVisiable = false
      if (this.formEditStatus === 12 && !withoutAlert) {
        // 只有在编辑状态下才会提示
        this.$confirm(this.$t('report.isDiscard'), this.$t('status.warning'), {
          confirmButtonText: this.$t('buttons.confirm'),
          cancelButtonText: this.$t('buttons.cancel'),
          type: 'warning'
        }).then(() => {
          // 关闭单子
          if (!this.dialogModel) {
            this.closeCurrentTag()
          } else {
            this.$nextTick(() => {
              this.$emit('AbortForm')
            })
          }
        }).catch(() => {
          console.error('释放编辑锁失败！')
          return
        })
      } else {
        // 关闭单子
        if (!this.dialogModel) {
          this.closeCurrentTag()
        } else {
          this.$nextTick(() => {
            this.$emit('AbortForm')
          })
        }
      }
    },
    PrintPreview() {
      // 打印导出预览
      // this.$refs.reportEditor.handlePrintReport()
      // alert('打印预览')
    },
    handlePrint(sheetGuid) {
      // 处理打印
      print.handlePrintReport(this.$refs.reportEditor, sheetGuid, 'print')
    },
    handlePreview(sheetGuid) {
      // 处理预览
      print.handlePrintReport(this.$refs.reportEditor, sheetGuid, 'preview')
    },
    showPrintAlert() {
      this.$message({
        message: this.$t('report.printArea'),
        type: 'warning'
      })
    },
    updatePrintList(printObjectList) {
      this.printObjectList = printObjectList
    },
    HandleOutPutCommand(command) {
      switch (command) {
        case 'xlsx':
          this.$refs.reportEditor.OutputXlsxFile()
          break
        case 'pdf':
          this.$refs.reportEditor.ExportPdfFile()
          break
      }
    },
    HistoryFroms() {
      // 打开历史单据界面
      var nodeClone = {}
      nodeClone.routeType = 'preview'
      nodeClone.id = this.$refs.reportEditor.templateId
      nodeClone.templateId = nodeClone.id
      nodeClone.nodeId = `preview-${nodeClone.id}`
      nodeClone.name = `${this.$refs.reportEditor.templateAttribute.name}-${this.$t('buttons.history')}`
      nodeClone.routeType = 'preview'
      nodeClone.type = 0
      nodeClone.value = 191
      nodeClone.operationType = 3
      nodeClone.isEdit = false
      const url = `/${nodeClone.routeType}/${nodeClone.id}/0`
      nodeClone.path = url
      this.$router.push(url)
      this.$store.dispatch('SetLastTab', nodeClone)
      this.$store.dispatch('addView', nodeClone)
    },
    async handleSubmit() {
      this.defaultValue = this.activity.opinionTitle
      console.log(this.activity)
      if (this.activity.messageSpecId) {
        getDataSpecCombo(this.activity.messageSpecId).then(spec => {
          this.comboList = spec.data
        })
      } else {
        this.comboList = []
      }
      this.formData = await this.$refs.reportEditor.PrepareNewFormData()
      if (this.formData) {
        this.formData.nonce = this.$refs.reportEditor.recordId
        this.submitVisible = true
        this.editLoading = false
        this.submitDialogLoading = true
        this.submitCandidateList = { list: [] }
        getWorkFlowTaskCandidate(0, this.$route.params.workFlowId, this.formData).then(res => {
          this.submitCandidateList = res.data
          this.submitDialogLoading = false
        })
      }
    },
    setActivity(activity) {
      this.activity = activity
    },
    pushSubmit(params) {
      this.editLoading = true
      handleWorkFlowTask(+this.$route.params.workFlowId, undefined, 1, this.formData, params).then(res => {
        this.submitVisible = false
        this.$nextTick(() => {
          // this.editLoading = false
          if (res.data.code === 0) {
            this.workflowTaskId = res.data.taskId
            this.$refs.reportEditor.recordId = res.data.recordId
            this.$notify({
              title: this.$t('status.success'),
              message: `${res.data.message}`,
              type: 'success',
              duration: 3 * 1000
            })
            this.$nextTick(() => {
              if (this.submitCandidateList.list.length >= 0) {
                this.$refs.reportEditor.PrepareMailByHandle(8388608)
              }
              this.AbortForm()
            })
          } else {
            this.$alert(`${res.data.message}`, this.$t('status.warning'), {
              confirmButtonText: this.$t('buttons.confirm'),
              callback: action => {
                this.AbortForm()
              }
            })
          }
        })
      }).catch(exception => {
        this.submitVisible = false
        this.$nextTick(() => {
          // this.editLoading = false
        })
      })
    },
    // 流程相关
    // 0 暂存 1 提交
    async pushWorkFlow(ship) {
      // 启动新流程
      this.ChangeLoadingStatus(true)
      const data = await this.$refs.reportEditor.PrepareNewFormData(!ship, !ship)
      if (data) {
        data.nonce = this.$refs.reportEditor.recordId
        handleWorkFlowTask(+this.$route.params.workFlowId, undefined, ship, data).then(res => {
          this.ChangeLoadingStatus(false)
          if (res.data.code === 0) {
            this.workflowTaskId = res.data.workflowTaskId
            this.$refs.reportEditor.recordId = res.data.recordId
            this.$refs.reportEditor.workflowTaskId = res.data.workflowTaskId
            this.$notify({
              title: this.$t('status.success'),
              message: `${res.data.message}`,
              type: 'success',
              duration: 3 * 1000
            })
            if (ship && this.submitCandidateList.list.length >= 0) {
              this.$refs.reportEditor.PrepareMailByHandle(8388608)
            }
            this.AbortForm()
          } else {
            this.$alert(`${res.data.message}`, this.$t('status.warning'), {
              confirmButtonText: this.$t('buttons.confirm'),
              callback: action => {
                this.AbortForm()
              }
            })
          }
        }).catch(exception => {
          this.ChangeLoadingStatus(false)
        })
      }
    },
    SubmitWorkFlow() {
      // 提交流程步骤
    },
    SendBackWorkFlow() {
      // 回退任务
    },
    // ExecuteAllFormulas() {
    //   // 执行全部取数公式
    //   for (var index in this.queryFormulaList) {
    //     this.queryFormulaIds.push({ id: parseInt(this.queryFormulaList[index].id) })
    //   }
    //   this.ExecQueryFormula()
    // },
    // ExecuteSelectedFormulas() {
    //   if (this.$refs.queryFormulaList.selection.length > 0) {
    //     // 依次执行选择的手动执行取数公式
    //     for (var index in this.$refs.queryFormulaList.selection) {
    //       this.queryFormulaIds.push({ id: parseInt(this.$refs.queryFormulaList.selection[index].id) })
    //     }
    //     this.ExecQueryFormula()
    //   }
    // },
    // 执行取数公式
    // Obsolete
    ExecQueryFormula() {
      this.$refs.reportEditor.ExcuteQueryFormulaByHandle('ManualExecute')
    },
    fromulaTableRowClick(row) {
      this.$refs.queryFormulaList.toggleRowSelection(row)
    },
    UpdateQueryFormulaList(list) {
      this.queryFormulaList = list
    },
    changeFromType(newType) {
      this.formType = newType
    },
    buildMailButtons(mailInfo) {
      if (mailInfo) {
        this.sendMailButtonInfos = mailInfo.filter(info => (info.applyTime & 256) === 256)
      } else {
        this.sendMailButtonInfos = []
      }
      this.buttonRowSize()
    },
    sendMail(mailId) {
      this.$refs.reportEditor.ShowMailForm(mailId)
    },
    buildFieldButtons(buttonsInfo) {
      this.fieldbuttonInfos = buttonsInfo
    },
    handleReportDialogClose() {
      this.reportDialogVisible = false
    },
    buildConnectButtons(buttonsInfo) {
      buttonsInfo.forEach(info => {
        info.class = 'connect'
      })
      this.connectbuttonInfos = buttonsInfo
      this.buttonRowSize()
    },
    async getWorkFlowInfo(templateId) {
      console.time('获取流程信息')
      this.workFlowInfo = []
      var targetList = await getWorkFlowTargets(this.$store.getters.userId, templateId)
      console.timeEnd('获取流程信息')
      return targetList.data
    },
    async connectLinkHandler(infos, triggerRange, fieldId, rowIndex) {
      var fieldRange
      if (infos && infos.length === 1) {
        if (infos[0].type === 'repetition') {
          this.$message({
            message: '暂不支持同一字段同时绑定关联填报和超链接！',
            type: 'error'
          })
          return
        }
      }
      if (fieldId && triggerRange && !this.viewHost) {
        fieldRange = this.$refs.reportEditor.GetNameRangeJson(this.$refs.reportEditor.id2Info[fieldId].areaAlias)
        triggerRange.sheet = this.$refs.reportEditor.spreadSheet.activeSheet()._name()
        triggerRange = formatConverter.ConvertAllFormat2Json(triggerRange)
      }
      var notfoundMessage = ''
      for (var info of infos) {
        // 判断执行条件，确定是否执行
        var triggerInfo
        if (fieldId && triggerRange && !this.viewHost) {
          switch (this.$refs.reportEditor.dataSheets[info.targetTableId].extType) {
            case 1:
              // 向下扩展
              triggerInfo = {
                top: triggerRange.topLeft.row - fieldRange.topLeft.row,
                length: triggerRange.bottomRight.row - triggerRange.topLeft.row + 1
              }
              break
            case 2:
              // 向右扩展
              triggerInfo = {
                top: triggerRange.topLeft.col - fieldRange.topLeft.col,
                length: triggerRange.bottomRight.col - triggerRange.topLeft.col + 1
              }
              break
            case 3:
              // 交叉扩展
              // 上方和左侧区域的取值处理
              switch (this.$refs.reportEditor.id2Info[fieldId].extType) {
                case 1:
                  triggerInfo = {
                    top: triggerRange.topLeft.row - fieldRange.topLeft.row,
                    left: -1,
                    length: {
                      row: triggerRange.bottomRight.row - triggerRange.topLeft.row + 1,
                      col: -1
                    }
                  }
                  break
                case 2:
                  triggerInfo = {
                    top: -1,
                    left: triggerRange.topLeft.col - fieldRange.topLeft.col,
                    length: {
                      row: -1,
                      col: triggerRange.bottomRight.col - triggerRange.topLeft.col + 1
                    }
                  }
                  break
                case 3:
                  triggerInfo = {
                    top: triggerRange.topLeft.row - fieldRange.topLeft.row,
                    left: triggerRange.topLeft.col - fieldRange.topLeft.col,
                    length: {
                      row: triggerRange.bottomRight.row - triggerRange.topLeft.row + 1,
                      col: triggerRange.bottomRight.col - triggerRange.topLeft.col + 1
                    }
                  }
                  break
              }
              break
          }
        }
        if (!(info.expression || info.execExpression) || (await this.$refs.reportEditor.excuteDecide(info.targetTableId || info.templateId, triggerInfo, info.param || info.execParam, info.expression || info.execExpression)).length) {
          if (await this.connectLinkClick(+info.id, undefined, info.class || info.type, undefined, rowIndex)) {
            return
          } else {
            notfoundMessage = ''
          }
        } else {
          notfoundMessage = info.unhandleMessage
        }
      }
      this.$message({
        message: notfoundMessage || '没有找到合适的单据！',
        type: 'warning'
      })
    },
    async connectLinkClick(command, recordId, type, currentType, rowIndex) {
      var result = false
      this.ChangeLoadingStatus(true)
      this.currentButton = command
      this.loadingCommand = command
      this.linkReportList = []
      var item
      switch (type) {
        case 'connect':
          // 开始处理
          item = this.$refs.reportEditor.connectInfos.find(info => info.id === command)
          // 判断关联类型
          if (!item.connectType) {
            // 填报新单据
            if (item.connectFlag) {
              this.handleCommand = command
              result = await this.linkHandler(command, recordId, item, 1, true, rowIndex) || false
              if (!result) {
                result = await this.connectHandler(item, command, rowIndex) || false
              }
            } else {
              result = await this.connectHandler(item, command, rowIndex) || false
            }
          } else if (item.connectType === 1) {
            // 打开老单据
            this.handleCommand = command
            result = await this.linkHandler(command, recordId, item, 1, true, rowIndex) || false
            if (item.connectFlag && !result) {
              result = await this.connectHandler(item, command, rowIndex) || false
            }
          }
          break
        case 'link':
          this.handleCommand = command
          item = currentType ? this.$refs.reportEditor.connectInfos.find(info => info.id === command) : this.$refs.reportEditor.linkInfos.find(info => info.id === command)
          result = await this.linkHandler(command, recordId, item, currentType, undefined, rowIndex) || false
          break
      }
      this.loadingCommand = null
      this.ChangeLoadingStatus(false)
      return result
    },
    async connectHandler(item, command, rowIndex) {
      // 权限判断
      const permission = await GetTemplatePermission(this.$store.getters.userId, item.templateId)
      if (!permission.data.create) {
        this.$message.error('您没有新建单据的权限！')
        return
      }
      var createText = this.$t('buttons.create')
      await this.$refs.reportEditor.GetConnectParam(command, rowIndex)
      // 判断是不是带流程单据
      var workflowInfo = await this.getWorkFlowInfo(item.templateId)
      // 开始执行
      if (item.targetMode === null || (workflowInfo && workflowInfo.length)) {
        var routerTemp
        if (workflowInfo && workflowInfo.length) {
          routerTemp = {
            name: `${workflowInfo[0].name}-${this.$t('buttons.start')}`,
            nodeId: `createWorkFlow-${item.templateId}`,
            templateId: item.templateId,
            routeType: 'createWorkFlow',
            model: 0,
            path: `/workFlow/${item.templateId}/${workflowInfo[0].id}/0`
          }
        } else {
          routerTemp = {
            name: `${item.templateName}-${createText}`,
            nodeId: `create-${item.templateId}`,
            templateId: item.templateId,
            connectTemplateId: this.$refs.reportEditor.templateId,
            connectId: item.id,
            connectRecordId: -1, // (this.$refs.reportEditor.editModel === 0 || this.$refs.reportEditor.editModel === 1) ? -1 : this.$refs.reportEditor.recordId,
            routeType: 'create',
            model: 0,
            path: `/report/${item.templateId}/0`
          }
        }
        this.$router.push(routerTemp.path)
        this.$store.dispatch('SetLastTab', routerTemp)
        this.$store.dispatch('addView', routerTemp)
      } else {
        this.reportTitle = `${item.templateName}-${createText}`
        this.dataRow = {
          templateId: item.templateId,
          recordId: 0
        }
        this.model = 0
        this.connectData = {
          templateId: this.$refs.reportEditor.templateId,
          connectId: item.id,
          recordId: -1 // (this.$refs.reportEditor.editModel === 0 || this.$refs.reportEditor.editModel === 1) ? -1 : this.$refs.reportEditor.recordId
        }
        this.$emit('handleConnect', this.dataRow, this.model, this.connectData, this.reportTitle)
      }
      return true
    },
    async linkHandler(command, recordId, item, type, hideMsg, rowIndex) {
      const checkStatus = async (templateId, rid, openType) => {
        console.log('检查单据状态')
        if (openType === 2) {
          try {
            // 编辑状态打开则检查单据状态
            const formData = (await getFormData(templateId, rid)).data
            let masterId = 10000000000
            console.log(formData)
            for (var tableId in formData) {
              masterId = masterId > tableId ? tableId : masterId
              break
            }
            const formStatus = formData[masterId][0].r13
            if (formStatus === 2 || formStatus === 3) {
              openType = 1
              this.$message({
                message: '单据当前状态无法编辑！',
                type: 'warning'
              })
            }
          } catch (ex) {
            openType = 1
          }
        }
        return openType
      }
      if (!recordId) {
        var params = await this.$refs.reportEditor.GetLinkParam(command, type, rowIndex)
        if (params instanceof Error) {
          this.ChangeLoadingStatus(false)
          return false
        }
        // console.log(params)
        var linkSheetList = type ? await getConnectLinkSheetList(command, {}, params) : await getLinkSheetList(command, {}, params)
        if (linkSheetList.status >= 200 && linkSheetList.status < 300) {
          if (linkSheetList.data.data.length) {
            if (linkSheetList.data.data.length > 1) {
              try {
                const attachCol = linkSheetList.data.header.filter(item => item.baseType === 5 || item.baseType === 6)
                if (attachCol && attachCol.length) {
                  for (var col of attachCol) {
                    for (var rowdata of linkSheetList.data.data) {
                      rowdata[col.column] = rowdata[col.column] ? JSON.parse(rowdata[col.column]) : ''
                      if (col.baseType === 5 && rowdata[col.column] && rowdata[col.column].data && rowdata[col.column].data[0]) {
                        const imgResult = await downloadFile(rowdata[col.column].data[0].id, undefined, 48)
                        rowdata[col.column].data[0].thumbnail = imgResult.data
                      }
                    }
                  }
                }
              } catch (ex) {
                console.error(ex)
              }
              this.linkReportListType = type
              this.linkReportList = linkSheetList.data
              this.showLinkReportList = true
            } else {
              this.connectLinkClick(command, linkSheetList.data.data[0].rid, 'link', type, rowIndex)
            }
            return true
          } else {
            // 没有取到数据
            if (!hideMsg) {
              this.$message(this.$t('report.noInfo'))
            }
          }
        } else {
          // 没有取到数据
          if (!hideMsg) {
            this.$message(this.$t('report.noInfo'))
          }
        }
        // console.log(linkSheetList)
        // this.showLinkReportList = true
      } else {
        // 打开单据
        item.openType = await checkStatus(item.templateId, recordId, item.openType)
        if (item.targetMode === null) {
          const routerTemp = {
            name: `${item.templateName}-${this.$t('buttons.check')}`,
            nodeId: `check-${recordId}-${item.templateId}`,
            templateId: item.templateId,
            recordId: recordId,
            openType: item.openType,
            routeType: 'check',
            model: 2,
            path: `/report/${item.templateId}/${recordId}/2`
          }
          this.$router.push(routerTemp.path)
          this.$store.dispatch('SetLastTab', routerTemp)
          this.$store.dispatch('addView', routerTemp)
        } else {
          this.reportTitle = `${item.templateName}-${this.$t('buttons.check')}`
          this.dataRow = {
            templateId: item.templateId,
            recordId: recordId,
            openType: item.openType
          }
          this.$emit('handleLink', this.dataRow, 2, this.reportTitle)
        }
        this.showLinkReportList = false
        return true
      }
    },
    changeLinkParam(showList, linkList) {
      if (showList !== undefined) {
        this.showLinkReportList = showList
      }
      if (linkList) {
        this.linkReportList = linkList
      }
    },
    buildActionButtons(actionInfos) {
      this.actionButtons = actionInfos
      this.buttonRowSize()
    },
    async actionButtonClick(actionId) {
      if (!actionId) {
        return
      }
      // 点击按钮触发执行命令
      this.hendleActionCommand = actionId
      this.actionRunning = true
      await this.$refs.reportEditor.ExcuteTemplateAction(actionId)
      this.actionRunning = false
    },
    changeSize(height, width) {
      this.$emit('changeSize', height, width)
      // },
      // showImageViewer() {
      //   this.imageviewerVisiable = true
      //   this.$nextTick(() => {
      //     this.$refs.ImageViewer.viewer.show()
      //   })
    },
    handleReview(action) {
      this.formLoading = true
      this.$nextTick(() => {
        switch (action) {
          case 1:
            console.log('审核')
            reportOperation(this.$refs.reportEditor.templateId, this.$refs.reportEditor.recordId, 12).then(() => {
              this.$message({
                message: this.$t('alert.reviewSuccess'),
                type: 'success'
              })
              this.$refs.reportEditor.systemValue.r13 = 2
              this.formLoading = false
            }).catch(() => {
              // this.$message({
              //   message: this.$t('alert.reviewFailed'),
              //   type: 'error'
              // })
              this.formLoading = false
            })
            break
          case 0:
            console.log('反审')
            reportOperation(this.$refs.reportEditor.templateId, this.$refs.reportEditor.recordId, 13).then(() => {
              this.$message({
                message: this.$t('alert.cancelReviewSuccess'),
                type: 'success'
              })
              this.$refs.reportEditor.systemValue.r13 = 1
              this.formLoading = false
            }).catch(() => {
              // this.$message({
              //   message: this.$t('alert.cancelReviewFailed'),
              //   type: 'error'
              // })
              this.formLoading = false
            })
            break
          case -1:
            console.log('作废')
            this.$confirm(this.$t('alert.voidWarning'), this.$t('status.warning'), {
              confirmButtonText: this.$t('buttons.confirm'),
              cancelButtonText: this.$t('buttons.cancel'),
              type: 'warning'
            }).then(() => {
              reportOperation(this.$refs.reportEditor.templateId, this.$refs.reportEditor.recordId, 14).then(() => {
                this.$message({
                  message: this.$t('alert.voidSuccess'),
                  type: 'success'
                })
                this.$refs.reportEditor.systemValue.r13 = 3
                this.formLoading = false
              }).catch(() => {
                // this.$message({
                //   message: this.$t('alert.voidFailed'),
                //   type: 'error'
                // })
                this.formLoading = false
              })
            }).catch(() => {
              this.formLoading = false
            })
            break
          default:
            this.formLoading = false
            break
        }
      })
    },
    pageinationEnabled(type) {
      if (this.$refs.reportEditor) {
        const currentInfo = this.$refs.reportEditor.paginationItems.find(item => item.id === this.$refs.reportEditor.currentExtendTable)
        if (currentInfo) {
          if (type === -1) {
            return currentInfo.currentPage === 0
          } else if (type === 1) {
            return currentInfo.totalPage - currentInfo.currentPage <= 1
          }
        }
      }
      return true
    },
    paginationText() {
      if (this.$refs.reportEditor) {
        const currentInfo = this.$refs.reportEditor.paginationItems.find(item => item.id === this.$refs.reportEditor.currentExtendTable)
        if (currentInfo) {
          return `当前第${currentInfo.currentPage + 1}页，共${currentInfo.totalPage}页合计${currentInfo.totalRecord}条记录`
        }
      }
      return '当前选中的区域不需要翻页'
    },
    pageChange(type) {
      const currentInfo = this.$refs.reportEditor.paginationItems.find(item => item.id === this.$refs.reportEditor.currentExtendTable)
      if (currentInfo) {
        if ((type === -1 && currentInfo.currentPage !== 0) || (type === 1 && currentInfo.currentPage < currentInfo.totalPage - 1)) {
          // 翻页
          currentInfo.currentPage += type
          this.$refs.reportEditor.RefreshExtendTable(currentInfo.id)
        }
      }
    },
    recalc() {
      this.recalcMark++
    }
  }
}
</script>
<style lang="scss" scoped>
.list-complete-item {
  transition: all 0.3s;
  display: inline-block;
}
.list-complete-enter,
.list-complete-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}
.taggle {
  .svg-icon {
    width: 18px !important;
    height: 18px !important;
  }
}
.action-buttons {
  margin-left: 10px;
}
.print-item {
  .preview-button {
    visibility: hidden;
    margin-left: 5px;
  }
}
.print-item:hover {
  .preview-button {
    visibility: visible;
    margin-left: 5px;
  }
}
.control-buttons {
  margin-left: -5px;
  .el-button {
    margin-left: 5px !important;
    margin-right: 5px !important;
  }
  .el-dropdown {
    margin-left: 0px !important;
    margin-right: 0px !important;
  }
}
.tips {
  float: right;
  line-height: 32px;
  font-size: 16px;
  .svg-icon {
    vertical-align: -2.5px;
  }
}
.form-flip {
  float: right;
  margin-left: 10px;
}
.el-icon-loading {
  padding: 0px !important;
}
</style>